/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains whether smartlook is enabled for the website
 */
export const smartlookEnabledContextKey = "smartlookEnabled";
